export const AI_AGENT_SERVICE_CONTENT_LINK =
  'https://biz.moneyforward.com/ai-agent';
